export const orders = 
{
  "active": [
    {
      "id": "554b090a-0999-4fc5-bc2e-4c7ead0bdc76",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-06T00:00:00+00:00",
      "product_installation_with_plot_number_address": {
        "zip": "41747",
        "location": "Viersen",
        "new_building_area_name": "Neubaugebiet",
        "district": "ddfgdfgA",
        "landing": "23",
        "plot": "2323"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station"
      ],
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "21.09. - 25.09.2020 (Kalenderwoche 39)",
      "installation_company_electricity": "Strom: Einköters GmbH",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Rainer Niehues",
      "uploaded_file_names_cadastral": [
        "4_house_distance_less_then_25.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_button_NEW.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "2342342",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 13
        },
        "own_contribution": 0,
        "subtotal": 3572,
        "total": 4453
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "E-Ladesäule, Terassenanschluss",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "2342342",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "2342342",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Neubaugebiet/Straßenname: Neubaugebiet, Gemarkung: ddfgdfgA, Flur: 23, Flurstück: 2323, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "4fdcf016-4725-40a3-a3e3-4063f46f2f8e",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "27.07. - 31.07.2020",
      "installation_company_electricity": "Strom: Elektro Mainz",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "111111",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 75,
        "subtotal": 499,
        "total": 424
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "111111",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "111111",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "29ab574e-e4b8-415c-bc96-213c26bf6394",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_22",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "27.07. - 31.07.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "abe2245a-6438-4293-a1c2-26a162a2d55a",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "water_heater"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": true,
      "appointment_for_connection": "27.07. - 31.07.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 1,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Küllenberg Haustechnik GmbH",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "232323",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 36.5,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 150,
        "subtotal": 3149,
        "total": 3897
      },
      "products": "Strom & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "Durchlauferhitzer",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "232323",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "232323",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "81ddc434-4bd5-43b2-9098-fff9dfa72ab1",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "17",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "27.07. - 31.07.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Georg Böcken",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 0,
        "subtotal": 3149,
        "total": 4047
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "b7cc899d-4fa5-42bc-be70-cda6320559b6",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "14",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_cooker",
        "terrace_connection",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "10.08. - 14.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "1"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Rainer Niehues",
      "uploaded_file_names_cadastral": [
        "3_kunden_journey.svg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gas.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "3434234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasherd, Terassenanschluss, Gasheizung mit Warmwasser",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "3434234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "3434234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "1cef60e0-a4b7-4972-a68d-4a52287dddd4",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_22",
      "number_of_charging_station": 3,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_button_NEW.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "4",
          "zip": "44137"
        },
        "phone_number": "4234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "4",
          "zip": "44137"
        },
        "phone_number": "4234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "4",
          "zip": "44137"
        },
        "phone_number": "4234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "c244598c-a968-4492-9aaa-6e92453fde25",
      "user_id": "Wi8eO31pRe1OWtRSxrnQ",
      "request_date": "2020-05-26T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "18",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "water_heater",
        "heat_pump_hot_water"
      ],
      "gas_installations": [
        "gas_heating_hot_water",
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": true,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "27.07. - 31.07.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "electricity_pricings": {
        "heat_pump": "1",
        "e_charging_station": "0",
        "water_heater": 4,
        "requires_grid_crosspoint": "1"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Küllenberg Haustechnik GmbH",
      "uploaded_file_names_cadastral": [
        "3_resdochao.JPG",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_resdochao.JPG",
        ""
      ],
      "applicant": {
        "surname": "R",
        "name": "W",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "18",
          "zip": "41747"
        },
        "phone_number": "1233",
        "email": "w.rispler@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 225,
        "subtotal": 3648,
        "total": 4321
      },
      "products": "Strom, Erdgas & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "Durchlauferhitzer, Wärmepumpe mit Warmwasser, Gasheizung mit Warmwasser, Terassenanschluss",
      "landowner": {
        "surname": "R",
        "name": "W",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "18",
          "zip": "41747"
        },
        "phone_number": "1233",
        "email": "w.rispler@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "R",
        "name": "W",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "18",
          "zip": "41747"
        },
        "phone_number": "1233",
        "email": "w.rispler@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "0ca34720-abae-4357-844e-c13a7b10651c",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-05-28T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "14",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "10.08. - 14.08.2020",
      "installation_company_electricity": "Strom: Udo Hütten",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_electricity.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Mainz",
          "street": "Markt",
          "street_number": "3",
          "zip": "55116"
        },
        "phone_number": "364564",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Mainz",
          "street": "Markt",
          "street_number": "3",
          "zip": "55116"
        },
        "phone_number": "364564",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Mainz",
          "street": "Markt",
          "street_number": "3",
          "zip": "55116"
        },
        "phone_number": "364564",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "73801914-6c00-4159-9d73-295264d3ffa8",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-05-28T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Hauptstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "heat_pump_hot_water",
        "water_heater",
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": true,
      "appointment_for_connection": "14.09. - 18.09.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "1",
        "e_charging_station": "1",
        "water_heater": 4,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_hintergrund.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gas.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Köln",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "51103"
        },
        "phone_number": "63645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 150,
        "subtotal": 3149,
        "total": 3897
      },
      "products": "Strom & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "Wärmepumpe mit Warmwasser, Durchlauferhitzer, E-Ladesäule",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Köln",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "51103"
        },
        "phone_number": "63645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Köln",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "51103"
        },
        "phone_number": "63645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "5c23924f-79dc-42bb-9e07-f615b61651c0",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "Eingangsbestatigung_Email (1).pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "Eingangsbestatigung_Email (2).pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "e69afcf9-6130-4ea0-9d9f-35d5bd73930b",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "11",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "10.08. - 14.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "Eingangsbestatigung_Email (2).pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "AuftragseingangSachbearbeiter_Email.pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017622211222",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017622211222",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017622211222",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "2da3b004-22a2-4590-a36f-f23d15fab096",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Eckehard Dubberke",
      "uploaded_file_names_cadastral": [
        "3_Eingangsbestatigung_Email (2).pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_Eingangsbestatigung_Email (1).pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "e03a6acc-2245-457a-8173-ab8ed12c65d2",
      "user_id": "OIwbrNuJ6ukftmoFXkdc",
      "request_date": "2020-06-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_355vta9c2ko21.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_355vta9c2ko21.jpg",
        ""
      ],
      "applicant": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 0,
        "subtotal": 3149,
        "total": 4047
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "75034201-a485-4c7b-a902-e8feec0a3ff3",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Elektro Mainz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "4_Screenshot at 2020-06-02 16-33-21.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_Screenshot at 2020-06-02 16-33-21.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01761111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01761111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01761111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "19cb4e11-2474-4343-91e0-2c219e7afdde",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "34",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "4_Items.jpeg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_hintergrund.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "23423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "23423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Sankt Augustin",
          "street": "Markt",
          "street_number": "3",
          "zip": "53757"
        },
        "phone_number": "23423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "bf2a7440-4274-4e49-af35-bba6937e9fcd",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-18T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "34",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_22",
      "number_of_charging_station": 3,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        "4_Hintergrund.png"
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 75,
        "subtotal": 499,
        "total": 424
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Wallbox bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "d2735433-c84e-403d-b4b0-06a229fad182",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Hauptstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station",
        "water_heater"
      ],
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 1,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_kombi.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 3648,
        "total": 4546
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "E-Ladesäule, Durchlauferhitzer, Terassenanschluss",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "c5b812d0-dc0c-40a9-b0c0-6bdc4a5f81ee",
      "user_id": "OIwbrNuJ6ukftmoFXkdc",
      "request_date": "2020-06-04T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_355vta9c2ko21.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_355vta9c2ko21.jpg",
        ""
      ],
      "applicant": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "13123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "13123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "13123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "01a82d1c-d896-4664-ac57-94cc9e48328f",
      "user_id": "OIwbrNuJ6ukftmoFXkdc",
      "request_date": "2020-06-05T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_355vta9c2ko21.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_355vta9c2ko21.jpg",
        ""
      ],
      "applicant": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Zwölfer",
        "name": "Martin",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Kreuzstraße",
          "street_number": "12",
          "zip": "53225"
        },
        "phone_number": "123123123123",
        "email": "m.zwoelfer@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "70754598-d05c-4b2d-bb36-684012d29f05",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-06-08T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station"
      ],
      "gas_installations": [
        "gas_cooker",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Rainer Niehues",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "gas_pricings": {
          "price": 499,
          "sum_kva": 0
        },
        "own_contribution": 0,
        "subtotal": 3648,
        "total": 4546
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "E-Ladesäule, Gasherd, Gasheizung mit Warmwasser",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_TECHNICAL_FEASIBILITY"
    },
    {
      "id": "0a9cedfe-73bd-4b0d-866b-2976c9c85a4e",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-06-08T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station"
      ],
      "gas_installations": [
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Küllertz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Mihm Team Viersen GmbH",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "gas_pricings": {
          "price": 499,
          "sum_kva": 10
        },
        "own_contribution": 0,
        "subtotal": 3648,
        "total": 4546
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "E-Ladesäule, Gasherd",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "bc2fbb32-defc-49c2-abee-6a5584eb3ebe",
      "user_id": "JwnCfVjs1w2czlqCNQ0V",
      "request_date": "2020-06-09T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_1_20200605_123735.jpg",
        "4_1_20200605_123735.jpg"
      ],
      "uploaded_file_names_blueprint": [
        "1_3_20200605_123841.jpg",
        "2_2_20200605_123749.jpg"
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 0,
        "subtotal": 3149,
        "total": 4047
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "13947d86-2963-4b92-b1d2-8ec3689605e1",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-10T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Stephan Maaßen",
      "uploaded_file_names_cadastral": [
        "4_gas_cooker.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gasherd.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 10
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasherd",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "1139a086-0e90-4cc9-ad3e-2a51ab07e3f4",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-15T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "4_gas_cooker.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gasherd.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "1",
          "zip": "41747"
        },
        "phone_number": "07111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "1",
          "zip": "41747"
        },
        "phone_number": "07111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "1",
          "zip": "41747"
        },
        "phone_number": "07111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "f23ce3a7-0477-42b0-92c3-7bc7d5184dc1",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-15T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Holger Coenen",
      "uploaded_file_names_cadastral": [
        "4_gas_cooker.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gasherd.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "111",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 10
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasherd",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "111",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "111",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "1cc356ca-9971-4193-8066-8004706de2b1",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-15T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Feuerstein Haustechnik",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gasherd.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gas_cooker.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CREATED"
    },
    {
      "id": "1e9097f1-e412-40a2-b8cb-fb9fed53d153",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-16T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas_cooker.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "11",
          "zip": "41747"
        },
        "phone_number": "07113242143",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "11",
          "zip": "41747"
        },
        "phone_number": "07113242143",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "11",
          "zip": "41747"
        },
        "phone_number": "07113242143",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CONFIRMED"
    },
    {
      "id": "837f1e74-abc9-41ca-ac84-430ba6addd4b",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-16T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Michael Müller",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gasherd.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "071111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CONFIRMED"
    },
    {
      "id": "f588dc53-72cd-43f5-9a1f-02e294e15326",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-18T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "44",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_11",
      "number_of_charging_station": 3,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Einköters GmbH",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_house_distance_more_then_25.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "2_house_distance_less_then_25.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Frankfurt am Main",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "60316"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Frankfurt am Main",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "60316"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Frankfurt am Main",
          "street": "Burgstraße",
          "street_number": "22",
          "zip": "60316"
        },
        "phone_number": "53453453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CONFIRMED"
    },
    {
      "id": "361f9c8d-414b-48b7-8342-1b03c7d66cc3",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-18T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "32",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_22",
      "number_of_charging_station": 4,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_button_NEW.jpg",
        "4_house_distance_more_then_25.jpg"
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "2353453535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "2353453535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "2353453535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CONFIRMED"
    },
    {
      "id": "ee61c3e5-948b-4060-b688-89bb116a30b6",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-18T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Hauptstraße",
        "street_number": "3",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_11",
      "number_of_charging_station": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_hintergrund.jpg",
        "4_kunden_journey.svg"
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "2342423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "2342423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "2342423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CONFIRMED"
    },
    {
      "id": "44e6fe81-5ee7-4f1d-8fd9-2acafb496a2e",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-18T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "34",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_22",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "5353453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 11
        },
        "own_contribution": 75,
        "subtotal": 499,
        "total": 424
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "5353453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "5353453",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "ca654304-ff6d-4699-993b-3f8d951e5295",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-19T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_11",
      "number_of_charging_station": 1,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "installation_company_electricity": "Strom: Einköters GmbH",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_Bauplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "c99c0748-8dd1-4a07-9fe5-992e6a040756",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-19T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_heating_hot_water",
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Georg Böcken",
      "uploaded_file_names_cadastral": [
        "4_Lageplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_Bauplan.pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Deutschland",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 30
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasheizung mit Warmwasser, Gasherd",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Deutschland",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Deutschland",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "6439226a-bf15-47e1-b33c-2fc6b6e0a4f7",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-19T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_cooker",
        "terrace_connection",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "17.08. - 21.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Roland Erdtelt",
      "uploaded_file_names_cadastral": [
        "4_Lageplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_Bauplan.pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "08333",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 43
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasherd, Terassenanschluss, Gasheizung mit Warmwasser",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "08333",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "08333",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "fdd681c0-b152-409e-a2f9-4cec2352faf7",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "AuftragseingangSachbearbeiter_Email (2).pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "Eingangsbestatigung_Email (2).pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017611122211",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Terassenanschluss",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017611122211",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "017611122211",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING",
      "order_note": "asdfasdfasdf"
    },
    {
      "id": "8688d299-5b1e-4af3-a9f6-6db9df7d38fa",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-22T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Michael Hintzen",
      "uploaded_file_names_cadastral": [
        "4_Lageplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_BA_B_V_Weyers_Burghof__Waldniel.pdf",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "0178822112",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 10
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Gasherd",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "0178822112",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Münster",
          "street": "Rektoratsweg",
          "street_number": "11",
          "zip": "48159"
        },
        "phone_number": "0178822112",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "78cd569c-0ac7-4080-a212-83cfab18d579",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-25T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 22
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_APPOINTMENT_PENDING"
    },
    {
      "id": "578b5030-c501-4a9e-a533-fe860d658ebb",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-22T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "own_contribution": 0,
        "subtotal": 3149,
        "total": 4047
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "28a3859d-c66b-4b9a-99bc-802127ca0f1d",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-22T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_22",
      "number_of_charging_station": 3,
      "number_of_charging_points": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        "4_hintergrund.jpg"
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 22
        },
        "own_contribution": 75,
        "subtotal": 499,
        "total": 424
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Markt",
          "street_number": "5",
          "zip": "13597"
        },
        "phone_number": "345345345",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "05b65e97-508f-458a-bc98-e3c7f7ccb722",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-23T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_22",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Küllertz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_Bauplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Wallbox bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "01711111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "34acc8f7-9e16-49cf-99ca-b9c5952dcc52",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-23T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 4,
      "number_of_charging_points": 4,
      "e_charging_station_controllable_selected": true,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_Bauplan.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 0,
          "sum_kva": 11
        },
        "own_contribution": 0,
        "subtotal": 0,
        "total": 0
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "12",
          "zip": "41747"
        },
        "phone_number": "0176111111",
        "email": "r.isaev@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "9e72db22-e8ef-4b97-a15d-b38f95100b30",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-24T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "gas",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "additional_phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 0
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Haushaltsbedarf",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "additional_phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "additional_phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "a5b1ab73-84f3-4fee-8e40-929d8dcd2cf4",
      "user_id": "BdRFKCK2JIjEVPSWWnSy",
      "request_date": "2020-06-24T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "20",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "gas_installations": [
        "gas_cooker",
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": true,
      "gas_less_than_5m_selected": true,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: elo/WKG",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Udo Reichel",
      "uploaded_file_names_cadastral": [
        "4__coffee.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1__coffee.png",
        ""
      ],
      "applicant": {
        "title": "Firma",
        "company_name": "Systems",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Kurfürstendamm",
          "street_number": "43",
          "zip": "34893"
        },
        "phone_number": "0715554598",
        "email": "p.jordan@conventic.com",
        "preferred_contact_channel": "E-Mail",
        "surname": "Systems",
        "name": ""
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 499,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2650,
          "water_building_costs": 998
        },
        "gas_pricings": {
          "price": 0,
          "sum_kva": 23
        },
        "own_contribution": 150,
        "subtotal": 3149,
        "total": 3897
      },
      "products": "Strom, Erdgas & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "Gasherd, Terassenanschluss",
      "landowner": {
        "title": "Firma",
        "company_name": "Systems",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Kurfürstendamm",
          "street_number": "43",
          "zip": "34893"
        },
        "phone_number": "0715554598",
        "email": "p.jordan@conventic.com",
        "preferred_contact_channel": "E-Mail",
        "surname": "Systems",
        "name": ""
      },
      "different_landowner": false,
      "invoice_address": {
        "title": "Firma",
        "company_name": "Systems",
        "address": {
          "country": "Deutschland",
          "city": "Berlin",
          "street": "Kurfürstendamm",
          "street_number": "43",
          "zip": "34893"
        },
        "phone_number": "0715554598",
        "email": "p.jordan@conventic.com",
        "preferred_contact_channel": "E-Mail",
        "surname": "Systems",
        "name": ""
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "41e6cb43-87f2-49f5-bce9-7bc754e08341",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-24T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "34",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_22",
      "number_of_charging_station": 3,
      "number_of_charging_points": 4,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Udo Hütten",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_uassohg.jpeg",
        "4_kunden_journey__SS.svg"
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "234234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 499,
          "sum_kva": 44
        },
        "own_contribution": 75,
        "subtotal": 499,
        "total": 424
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations": "Ladesäule bis 22 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "234234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "234234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "a014af59-fe0a-4aff-898f-56a04fa40be0",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-25T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "15",
        "zip": "41747"
      },
      "product": "gas",
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Rainer Niehues",
      "uploaded_file_names_cadastral": [
        "3_kombi.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_hintergrund.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "24234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "gas_pricings": {
          "price": 499,
          "sum_kva": 13
        },
        "own_contribution": 0,
        "subtotal": 499,
        "total": 499
      },
      "products": "Erdgas",
      "presentable_installations": "Terassenanschluss",
      "installation_company_electricity": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "24234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6-8",
          "zip": "44137"
        },
        "phone_number": "24234234",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "e337cf11-f9b1-4e3e-aa94-8c2643deeb22",
      "user_id": "ArhQt75QdLC5OXkmwlis",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station",
        "heat_pump_hot_water"
      ],
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "1",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "1"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Udo Krämer",
      "uploaded_file_names_cadastral": [
        "4_gasherd.png",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_gas_cooker.png",
        ""
      ],
      "applicant": {
        "surname": "Isaev",
        "name": "Rustam",
        "address": {
          "country": "Germany",
          "city": "Viersen",
          "street": "Rektoratstraße",
          "street_number": "21",
          "zip": "41747"
        },
        "phone_number": "01761111111",
        "email": "r.isaev@slenderiser.de",
        "preferred_contact_channel": "Telefon",
        "title": ""
      },
      "alternative_invoice_recipient": {
        "title": "Frau",
        "name": "Max",
        "surname": "Mustermann",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "12",
          "zip": "53177"
        }
      },
      "additional_contact_person": {
        "name": "John",
        "surname": "Doe",
        "phone_number": "01761111111",
        "email": "test@mai.ru"
      },
      "landowner": {
        "title": "",
        "name": "Hans",
        "surname": "Muller",
        "address": {
          "country": "Germany",
          "city": "Heidelberg",
          "street": "Hauptstraße",
          "street_number": "12",
          "zip": "69117"
        }
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": true
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 13
        },
        "own_contribution": 0,
        "subtotal": 3572,
        "total": 4453
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "E-Ladesäule, Wärmepumpe mit Warmwasser, Terassenanschluss",
      "different_landowner": true,
      "invoice_address": {
        "title": "Frau",
        "name": "Max",
        "surname": "Mustermann",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "12",
          "zip": "53177"
        }
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf",
        "Zustimmungserklärung-Grundstückseigentümer.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "1612b530-afe1-4054-ad12-1d85203d2e4c",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "17",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18a",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "739f8a56-59c4-4f1e-aede-4077746e4c68",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "gas_installations": [
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "31.08. - 04.09.2020",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 20
        },
        "own_contribution": 0,
        "subtotal": 3572,
        "total": 4453
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "Gasheizung mit Warmwasser",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "27832c40-9e43-4573-a6ac-17e9941f27f9",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "18a",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 18a, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 18a, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "c1ba716d-aa69-4cfd-b8c1-5ac163ac9b6a",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "heat_pump_hot_water"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "1",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Wärmepumpe mit Warmwasser",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_FULFILLED"
    },
    {
      "id": "8cab2902-2ddf-40a6-beff-aae735937c3b",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "17",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 17, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 17, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "f677b740-3469-40db-a050-bb12e415a3ee",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "water_heater"
      ],
      "gas_installations": [
        "terrace_connection",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": true,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "24.08. - 28.08.2020",
      "installation_company_electricity": "Strom: Udo Hütten",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 1,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_house_distance_less_then_25.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_kombi.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "4645645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 33
        },
        "own_contribution": 225,
        "subtotal": 3572,
        "total": 4228
      },
      "products": "Strom, Erdgas & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "Durchlauferhitzer, Terassenanschluss, Gasheizung mit Warmwasser",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "4645645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Deutschland",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "4645645645",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 23, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "9e4b2af0-6716-4b14-833d-444510005a92",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-01T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "d72124af-0cae-4977-8744-2877316cd244",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-06-30T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "22",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station",
        "water_heater",
        "heat_pump_hot_water"
      ],
      "gas_installations": [
        "terrace_connection",
        "gas_heating_hot_water",
        "gas_cooker"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": true,
      "gas_less_than_5m_selected": true,
      "appointment_for_connection": "21.09. - 25.09.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "1",
        "e_charging_station": "1",
        "water_heater": 1,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_house_distance_more_then_25.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_button_NEW.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "3534534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 0,
          "sum_kva": 43
        },
        "own_contribution": 146,
        "subtotal": 3086,
        "total": 3821
      },
      "products": "Strom, Erdgas & Trinkwasser, mit Eigenleistung",
      "presentable_installations": "E-Ladesäule, Durchlauferhitzer, Wärmepumpe mit Warmwasser, Terassenanschluss, Gasheizung mit Warmwasser, Gasherd",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "3534534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "3534534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 22, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 22, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "dc9439e6-71d3-4615-9400-86502ee43a0a",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-01T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_3_20200629_125207.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_1_20200629_204212.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "ef78de59-50c6-418d-aeb8-b6e18e790a31",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-01T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "22",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "water_heater"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "14.09. - 18.09.2020",
      "installation_company_electricity": "Strom: Elektro Mainz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 4,
        "requires_grid_crosspoint": "1"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_kombi.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3534535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations": "Durchlauferhitzer",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3534535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3534535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 22, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 22, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_CANCELLED"
    },
    {
      "id": "f94b95ed-c5d4-4c6d-beed-bb2d8cbf80c4",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-01T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "gas_installations": [
        "terrace_connection",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "14.09. - 18.09.2020",
      "installation_company_electricity": "Strom: Elektro Mainz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_hintergrund.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_electricity.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 33
        },
        "own_contribution": 0,
        "subtotal": 3572,
        "total": 4453
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations": "Terassenanschluss, Gasheizung mit Warmwasser",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "534534534",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 23, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "43a5d8b6-25c8-4f93-8f49-b662499d36f5",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 4,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": 36.300000000000004
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "3 Ladesäule(n) mit 4 Ladepunkte(n) bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "f23bc675-aac5-48e0-b50b-c0d82aab0286",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "36.3"
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "3 Ladesäule(n) mit 2 Ladepunkte(n) bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "9f9e4295-ab99-4a43-8e84-b4ef277afaf7",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 1,
      "number_of_charging_points": 3,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "12.1"
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "1 Ladesäule(n) mit 3 Ladepunkte(n) bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "5330ac2d-f228-44ba-955f-02fdeb8dc104",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "21.09. - 25.09.2020",
      "installation_company_electricity": "Strom: Ralf Saveur",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_hintergrund.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3543535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "36.3"
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "3 Ladesäule(n) mit 2 Ladepunkte(n) bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3543535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Leipzig",
          "street": "Markt",
          "street_number": "5",
          "zip": "04109"
        },
        "phone_number": "3543535",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 12, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 12, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "439d19f8-eda0-4078-ae44-d0ff79bf641c",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_11",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "12.1"
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "6653f642-f790-4e19-ad52-88003be97dc3",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "36.3"
        },
        "own_contribution": 0,
        "subtotal": 486,
        "total": 486
      },
      "products": "Strom für E-Mobilität",
      "presentable_installations": "3 Ladesäule(n) mit 1 Ladepunkte(n) bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1212121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "d64fa006-2286-40a9-9ca7-cf6a59fd8a57",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-02T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "wallbox_11",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_bauplan1_aao.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "12.1"
        },
        "own_contribution": 73,
        "subtotal": 486,
        "total": 413
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations_short": "Ihre Wallbox",
      "presentable_installations": "Wallbox bis 11 kW",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Rektoratstraße 16, 41747 Viersen",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "9cf97a42-0835-4e83-9a5a-4c926a851bb5",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "documents": [
        "Eingangsbestätigung.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "df7f6d4f-8560-4b46-8ef5-7b41b1c08317",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "12121212",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "documents": [
        "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
        "Vorlage_Auftragsbestätigung_Email.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "0ce3faef-aee8-4702-b0dc-85a3da6ec79b",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1276767",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1276767",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "1276767",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "documents": [
        "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "bdce0ffb-ce85-4096-892a-9ba6af350b73",
      "user_id": "OV9ZfebSfpsNvX39y7I9",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "16",
        "zip": "41747"
      },
      "product": "electricity&water",
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "appointment_for_connection": "Netzanschlusstermin später vereinbaren",
      "installation_company_electricity": "Strom: Ist noch nicht beauftragt.",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "3_bauplan2.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_bauplan1.jpg",
        ""
      ],
      "applicant": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "23232323",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": false,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 14,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 0,
        "subtotal": 3086,
        "total": 3967
      },
      "products": "Strom & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "Haushaltsbedarf",
      "landowner": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "23232323",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Emmerich",
        "name": "Marcelo",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Kelvinstraße",
          "street_number": "18A",
          "zip": "53639"
        },
        "phone_number": "23232323",
        "email": "m.emmerich@slenderiser.de",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom & Trinkwasser, Rektoratstraße 16, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "534f28d0-867e-497c-a72b-2e9b8055c792",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "12",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station",
        "water_heater"
      ],
      "gas_installations": [
        "terrace_connection",
        "gas_heating_hot_water"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": true,
      "gas_less_than_5m_selected": true,
      "appointment_for_connection": "31.08. - 04.09.2020",
      "installation_company_electricity": "Strom: Sven Rongelraths",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 3,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Stephan Maaßen",
      "uploaded_file_names_cadastral": [
        "3_uassohg.jpeg",
        "4_kunden_journey__SS.svg"
      ],
      "uploaded_file_names_blueprint": [
        "1_house_distance_less_then_25.jpg",
        "2_Hintergrund.png"
      ],
      "applicant": {
        "title": "Frau",
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "234234234",
        "additional_phone_number": "234234234",
        "email": "l.loncar@conventic.com",
        "preferred_contact_channel": "Telefon"
      },
      "alternative_invoice_recipient": {
        "title": "Herr",
        "name": "Marcelo",
        "surname": "Emmerich",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        }
      },
      "additional_contact_person": {
        "title": "Herr",
        "name": "Sven",
        "surname": "Jansen",
        "phone_number": "232343344",
        "additional_phone_number": "23423424234",
        "email": "sven@email.com",
        "preferred_contact_channel": "email"
      },
      "landowner": {
        "title": "Herr",
        "name": "Patrick",
        "surname": "Jordan",
        "address": {
          "country": "Germany",
          "city": "Königswinter",
          "street": "Hauptstraße",
          "street_number": "12",
          "zip": "53639"
        }
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 0,
          "sum_kva": 33
        },
        "own_contribution": 146,
        "subtotal": 3086,
        "total": 3821
      },
      "products": "Strom, Erdgas & Trinkwasser, mit Eigenleistung",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "E-Ladesäule, Durchlauferhitzer, Terassenanschluss, Gasheizung mit Warmwasser",
      "different_landowner": true,
      "invoice_address": {
        "title": "Herr",
        "name": "Marcelo",
        "surname": "Emmerich",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        }
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, mit Eigenleistung, Rektoratstraße 12, 41747 Viersen.pdf",
        "Zustimmungserklärung-Grundstückseigentümer.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "d4ef138b-2dff-4f46-9161-f18827d0b24c",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Germany",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "electricity&water&gas",
      "electric_installations": [
        "e_charging_station",
        "water_heater"
      ],
      "gas_installations": [
        "terrace_connection"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": false,
      "gas_less_than_5m_selected": false,
      "appointment_for_connection": "14.09. - 18.09.2020",
      "installation_company_electricity": "Strom: Etienne Peitz-Eickels",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 1,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Ist noch nicht beauftragt.",
      "uploaded_file_names_cadastral": [
        "4_house_distance_less_then_25.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1_button_NEW.jpg",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "1111111111",
        "additional_phone_number": "222222222222",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "gas_pricings": {
          "price": 486,
          "sum_kva": 13
        },
        "own_contribution": 0,
        "subtotal": 3572,
        "total": 4453
      },
      "products": "Strom, Erdgas & Trinkwasser",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "E-Ladesäule, Durchlauferhitzer, Terassenanschluss",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "1111111111",
        "additional_phone_number": "222222222222",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "phone_number": "1111111111",
        "additional_phone_number": "222222222222",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom, Erdgas & Trinkwasser, Rektoratstraße 23, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "f5c4262a-8f31-464d-b23b-8e3d755bdde3",
      "user_id": "C3J8YDTQ8cSIkR6riNuQ",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "23",
        "zip": "41747"
      },
      "product": "eMobility",
      "e_mobility_installation": "charging_station_11",
      "number_of_charging_station": 3,
      "number_of_charging_points": 2,
      "e_charging_station_controllable_selected": false,
      "own_contribution_selected": true,
      "appointment_for_connection": "31.08. - 04.09.2020",
      "installation_company_electricity": "Strom: Elektro Mainz",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "0",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "uploaded_file_names_cadastral": [
        "3_gas.jpg",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "",
        ""
      ],
      "applicant": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "alternative_invoice_address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "124234",
        "additional_phone_number": "23423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "emobility_pricings": {
          "price": 486,
          "sum_kva": "36.3"
        },
        "own_contribution": 73,
        "subtotal": 486,
        "total": 413
      },
      "products": "Strom für E-Mobilität, mit Eigenleistung",
      "presentable_installations_short": "Ihre Ladestationen",
      "presentable_installations": "3 Ladestation(en) bis 11kW mit je 2 Ladepunkt(en)",
      "installation_company_gas": "",
      "landowner": {
        "surname": "Loncar",
        "name": "Lorna",
        "address": {
          "country": "Germany",
          "city": "Dortmund",
          "street": "Markt",
          "street_number": "6",
          "zip": "44137"
        },
        "alternative_invoice_address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        },
        "phone_number": "124234",
        "additional_phone_number": "23423423",
        "email": "l.loncar@conventic.com",
        "title": "",
        "preferred_contact_channel": "Nicht ausgewählt"
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Loncar",
        "name": "Lorna",
        "title": "",
        "address": {
          "country": "Germany",
          "city": "Bonn",
          "street": "Burgstraße",
          "street_number": "69",
          "zip": "53177"
        }
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom für E-Mobilität, mit Eigenleistung, Rektoratstraße 23, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    },
    {
      "id": "4fbbe983-8b4f-472e-a222-837ab4c2c4ee",
      "user_id": "BdRFKCK2JIjEVPSWWnSy",
      "request_date": "2020-07-03T00:00:00+00:00",
      "product_installation_full_address": {
        "country": "Deutschland",
        "city": "Viersen",
        "street": "Rektoratstraße",
        "street_number": "22",
        "zip": "41747"
      },
      "product": "electricity&water",
      "electric_installations": [
        "e_charging_station"
      ],
      "number_of_charging_station": 1,
      "number_of_charging_points": 1,
      "own_contribution_selected": true,
      "appointment_for_connection": "12.10. - 16.10.2020",
      "installation_company_electricity": "Strom: ETN Elektrotechnik Noll",
      "electricity_pricings": {
        "heat_pump": "0",
        "e_charging_station": "1",
        "water_heater": 0,
        "requires_grid_crosspoint": "0"
      },
      "installation_company_gas": "Erdgas und Trinkwasser: Hauser u. Veckes Haustechnik GmbH",
      "uploaded_file_names_cadastral": [
        "4_Linux-Academy-Ansible-Roles-Cheatsheet.pdf",
        ""
      ],
      "uploaded_file_names_blueprint": [
        "1__coffee.png",
        ""
      ],
      "applicant": {
        "surname": "Jordan",
        "name": "Patrick",
        "address": {
          "country": "Pakistan",
          "city": "Karachi",
          "street": "Karachi - Hyderabad Motorway",
          "street_number": "33",
          "zip": "42424"
        },
        "alternative_invoice_address": {
          "country": "Österreich",
          "city": "Wien",
          "street": "Burggasse",
          "street_number": "343",
          "zip": "44332"
        },
        "phone_number": "1337",
        "additional_phone_number": "6322",
        "email": "p.jordan@conventic.com",
        "preferred_contact_channel": "E-Mail",
        "title": ""
      },
      "permissions": {
        "perm_contract": true,
        "perm_forward_personal_dat": true,
        "perm_customer_satisfaction": false
      },
      "combined_pricings": {
        "electricity_pricings": {
          "price": 486,
          "sum_kva": 25,
          "increased_fusing": false
        },
        "water_pricings": {
          "price": 2600,
          "water_building_costs": 881
        },
        "own_contribution": 146,
        "subtotal": 3086,
        "total": 3821
      },
      "products": "Strom & Trinkwasser, mit Eigenleistung",
      "presentable_installations_short": "Ihr Einfamilienhaus",
      "presentable_installations": "E-Ladesäule",
      "landowner": {
        "surname": "Jordan",
        "name": "Patrick",
        "address": {
          "country": "Pakistan",
          "city": "Karachi",
          "street": "Karachi - Hyderabad Motorway",
          "street_number": "33",
          "zip": "42424"
        },
        "alternative_invoice_address": {
          "country": "Österreich",
          "city": "Wien",
          "street": "Burggasse",
          "street_number": "343",
          "zip": "44332"
        },
        "phone_number": "1337",
        "additional_phone_number": "6322",
        "email": "p.jordan@conventic.com",
        "preferred_contact_channel": "E-Mail",
        "title": ""
      },
      "different_landowner": false,
      "invoice_address": {
        "surname": "Jordan",
        "name": "Patrick",
        "title": "",
        "address": {
          "country": "Österreich",
          "city": "Wien",
          "street": "Burggasse",
          "street_number": "343",
          "zip": "44332"
        }
      },
      "presentable_user_receipt_subject": "Eingangsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen",
      "presentable_contract_request_subject": "Auftragseingang für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen",
      "presentable_contract_request_confirmation_subject": "Auftragsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen",
      "presentable_user_receipt_filename": "Eingangsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen.pdf",
      "presentable_contract_request_filename": "Auftragseingang für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen.pdf",
      "presentable_contract_request_confirmation_filename": "Auftragsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen.pdf",
      "documents": [
        "Auftragsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen.pdf",
        "Eingangsbestätigung für Strom & Trinkwasser, mit Eigenleistung, Rektoratstraße 22, 41747 Viersen.pdf"
      ],
      "order_metadata": {
        "order_type": "efh"
      },
      "order_status": "ORDER_RECEIVED"
    }
  ],
  "inactive": [
    
  ]
};